// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iQUo_","title":"styles_title__2iJ3w"};